<div class="w-100">
    <div class="row no-gutters col-12 d-flex align-items-center justify-content-end pr-0"
    style="margin-top: -10px;">
        <i class="fa fa-close pb-2" (click)="onConfirmClick()" style="cursor: pointer;"></i>
      </div>
    <figure style="margin: 0 !important;">
        <img [src]="url" alt="" width="100%" height="250">
    </figure>
</div>